import './BurgerMenu.scss';

import { CaretRight } from '@phosphor-icons/react';
import { Body, ButtonV2, isDefaultBrand, useConfig } from '@travelwin/core';
import { useTranslation } from 'react-i18next';

import { useNavbarItems } from '../../hooks';
import { NavItem } from '../../interfaces/NavBar';
import { FreeTrialBanner } from '../../pages/FreeTrialBanner/FreeTrialBanner';
import MobileStickyFullLayout from '../Layout/MobileStickyFullLayout';
import { Link } from '../Link';
import { useCreateStoreLink } from '../MobileStoreButton/useCreateStoreLink';

const className = 'c-BurgerMenu';

type BurgerMenuItemProps = {
  type: 'menu' | 'submenu';
  item: NavItem;
  handleNavItemClick: () => void;
};

const BurgerMenuItem = ({
  item,
  type,
  handleNavItemClick,
}: BurgerMenuItemProps) => {
  return (
    <li
      className={`${className}__dropdown--item ${className}__dropdown--item-${type}`}
      tabIndex={0}
      onClick={handleNavItemClick}
      onKeyDown={(e) => {
        if (e.key === 'Enter') {
          e.preventDefault();
          handleNavItemClick();
        }
      }}
    >
      <div className={`${className}__dropdown--item-container`}>
        {item.icon}
        <Body size={16} weight={'800'}>
          {item.label}
        </Body>
      </div>
      {Array.isArray(item.items) && item.items.length > 0 && (
        <CaretRight size={16} weight="bold" className={`${className}__caret`} />
      )}
    </li>
  );
};

const BurgerMenu = ({
  handleNavItemClick,
  expandedSubMenuId,
  isExpanded,
}: {
  handleNavItemClick: (item: NavItem) => void;
  expandedSubMenuId: string;
  isExpanded: boolean;
}) => {
  const { burgerMenuItems } = useNavbarItems();
  const { t } = useTranslation();
  const { WHITELABEL_BRAND } = useConfig();

  const currentSubMenu = burgerMenuItems.find(
    (item) => item.id === expandedSubMenuId,
  );

  const storeLink = useCreateStoreLink();

  return (
    <MobileStickyFullLayout isExpanded={isExpanded}>
      <ul className={`${className}__dropdown`}>
        {currentSubMenu
          ? currentSubMenu?.items?.map(
              (item: NavItem) =>
                item.visible && (
                  <BurgerMenuItem
                    item={item}
                    key={item.id}
                    type="submenu"
                    handleNavItemClick={() => handleNavItemClick(item)}
                  />
                ),
            )
          : burgerMenuItems.map(
              (item: NavItem) =>
                item.visible && (
                  <BurgerMenuItem
                    item={item}
                    key={item.id}
                    type="menu"
                    handleNavItemClick={() => handleNavItemClick(item)}
                  />
                ),
            )}
        {isDefaultBrand(WHITELABEL_BRAND) && (
          <div className={`${className}__button-container`}>
            <FreeTrialBanner variant="landing" />
            <ButtonV2 intent="support-violet" variant="secondary" asChild>
              {/*  Deep link by Appsflyer  */}
              <Link to={storeLink ?? 'https://app.simlocal.com/kIwv/l0aqsfuz'}>
                {t('navbar.downloadApp', 'Download App')}
              </Link>
            </ButtonV2>
          </div>
        )}
      </ul>
    </MobileStickyFullLayout>
  );
};

export default BurgerMenu;
